(() => {
  /**
   * Checks on an interval if jQuery is loaded.
   *
   * Reference source (https://stackoverflow.com/questions/7486309).
   *
   * @param {*} method - to run once the required libraries are loaded.
   * @param {Number} interval - lenght of time in ms to delay between required libaries check intervals.
   * @param {Number} timeout  - length of time in ms to stop libaries check after.
   * @param {Number} initialTime - Unix timestamp of initial check start.
   */
  function defer(method, interval = 100, timeout = 10000, initialTime = Date.now()) {
    if (window.jQuery) {
      method();
    } else if (Date.now() - initialTime > timeout) {
      console.warn("Script defer timed out after " + timeout + "ms before executing!");
    } else {
      setTimeout(function () {
        defer(method, interval, timeout, initialTime);
      }, interval);
    }
  }

  /**
   * Registers Handing-Tooltip listeners.
   */
  function registerHandingTooltip() {
    let handingGuideElement = $(document).find(".product-form__guides");

    // Checks and moves the handing guide next to the HulkApps or SwatchKing product options.
    if (handingGuideElement.length) {
      handingGuideElement.hide(); // Hide tooltip until finished trying to append

      const loopTimeStart = Date.now();
      const loopPostLoadTimeout = 750;
      const loopTotalTimeout = 10000;
      const loopInterval = 75;
      let doc_loaded = false;
      let loadTimeEnd = -1;

      // Searches for and returns the element if there is a HulkApps handing selector:
      function getHulkAppsSelector() {
        let returnVal = null;
        let hAppsOptionDiv = $(document).find(".hulkapps_option_name");
        if (hAppsOptionDiv != null && hAppsOptionDiv.length) {
          //checks for HulkApps div.
          hAppsOptionDiv.each(function () {
            // Iterates over each HulkApps option.
            if ($.trim($(this).text()).indexOf("Handing") != -1) {
              // Checks if a HulkApps option named 'Handing' is found.
              returnVal = $(this).find(".hulkapps-tooltip").empty(); //Sets return value to the found element.
              return true; // exits foreach
            }
          });
        }
        return returnVal;
      }

      // Searches for and returns true if there is a SwatchKing Handing Selector:
      function getSwatchKingSelector() {
        let returnVal = null;
        let sKingOptionDiv = $(document).find(".swatches, .swatches-type-products, .hover-enabled");
        if (sKingOptionDiv != null && sKingOptionDiv.length) {
          sKingOptionDiv.find('legend').each(function () {
            // Iterates over each SwatchKing option.
            let option_name = $(this).find('label');
            if ($.trim(option_name.text()).indexOf("Handing") != -1) {
              // Checks if a SwatchKing option with the substring 'Handing' is found.
              // returnVal = $(this).find('.swatch-label, .swatch-label-button'); //Sets return value to the found element.
              returnVal = $(this); //Sets return value to the found element.
              return true; // exits foreach
            }
          });
        }
        return returnVal;
      }

      // Iterates over functions in list, appends tooltip div to first to return a valid element:
      function try_tooltip_append(tooltip_div, getterFunctionsList) {
        for (let i = 0; i < getterFunctionsList.length; i++) {
          let selectorReturn = getterFunctionsList[i]();
          // Checks if returned value is an html element
          if (selectorReturn != null && selectorReturn.length) {
            tooltip_div.show().appendTo(selectorReturn); // Moves handing guide inside the returned selector element.
            return true;
          }
        }
        return false;
      }

      const functionsList = [getHulkAppsSelector, getSwatchKingSelector];

      // Runs loop every <loopInterval>ms for <loopTotalTimeout>ms to see if a selector element exists:
      let loopForever = setInterval(function () {
        const currentTime = Date.now();
        // Ends loop if tooltip was appended:
        if (try_tooltip_append(handingGuideElement, functionsList)) {
          clearInterval(loopForever);
          return;
        }
        // Ends the loop if the doc is loaded or if the elapsed time is greater than the defined timeout:
        else if ((doc_loaded && currentTime - loadTimeEnd > loopPostLoadTimeout) || currentTime - loopTimeStart > loopTotalTimeout) {
          clearInterval(loopForever);
          handingGuideElement.show();
          console.warn("Product-Handing-Tooltip relocation selector timed out before finding a matching element.");
          return;
        }
      }, loopInterval);

      // When document is finished loading, signal an end to the loop:
      $(document).ready(function () {
        setTimeout(function(){
          doc_loaded = true;
          loadTimeEnd = Date.now();
        },10000)
      });
    } else {
      console.error("Product-Handing-Tooltip relocation selector was unable to find a valid handing-tooltip to move!");
    }
  }

  // Wait until DOM is loaded
  document.addEventListener("DOMContentLoaded", () => {
    defer(registerHandingTooltip);
  });

 

})();


